<template>
  <div>
    <v-tabs show-arrows v-model="tabs" background-color="transparent">
      <v-tabs-slider color="gray"></v-tabs-slider>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EC_SERVICE') || this.user.roles.includes('EC_USER')">
        <v-tab>{{ $t("settings.headers.basicInformation") }}</v-tab>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EVC_ADMIN')">
        <v-tab>Nastavení stanice</v-tab>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN')">
        <v-tab>Testování stanice</v-tab>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EC_SERVICE')">
        <v-tab>Prvotní konfigurace stanice </v-tab>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EC_SERVICE') || this.user.roles.includes('EC_USER')">
        <v-tab-item class="ma-4">
          <template v-if="this.parameters != null && this.data != null">
            <v-row>
              <v-col cols="12">
                <h2>{{ $t("settings.basicInformation") }}</h2>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field disabled readonly :label="$t('settings.input') + ': '" v-model="this.input"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field disabled readonly :label="$t('settings.output') + ': '" v-model="this.output"></v-text-field>
              </v-col>
            </v-row>

            <StationSerialNumbers :data="data" />

            <StationVersions :data="data" />
          </template>
          <template v-else>
            <LoadingData />
          </template>
        </v-tab-item>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EVC_ADMIN')">
        <v-tab-item class="mx-4">
          <v-row>
            <v-col cols="12">
              <StationConfig />
            </v-col>
          </v-row>
        </v-tab-item>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN')">
        <v-tab-item class="mx-4">
          <v-row>
            <v-col cols="12">
              <StationTesting />
            </v-col>
          </v-row>
        </v-tab-item>
      </template>

      <template v-if="this.user.roles.includes('EC_ADMIN') || this.user.roles.includes('EC_SERVICE')">
        <v-tab-item class="mx-4">
          <v-row>
            <v-col cols="12">
              <StationConfigService />
            </v-col>
          </v-row>
        </v-tab-item>
      </template>
    </v-tabs>
    <UpgradeCore />
  </div>
</template>

<script>
import { mapState } from "vuex";

import StationConfig from "../../components/station/StationConfig.vue";
import StationConfigService from "../../components/station/StationConfigService.vue";
import StationSerialNumbers from "../../components/station/StationSerialNumbers.vue";
import StationTesting from "../../components/station/StationTesting.vue";
import StationVersions from "../../components/station/StationVersions.vue";

import LoadingData from "../../components/LoadingData.vue";
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Settings",
  components: {
    LoadingData,
    StationConfig,
    StationConfigService,
    StationSerialNumbers,
    StationTesting,
    StationVersions,
    UpgradeCore,
  },
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("user")),

      tabs: 0,

      timeoutDataTimer: null,
      timeoutParametersTimer: null,

      parameters: null,
      data: null,

      input: "",
      output: "",
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      users: (state) => state.users.all,
    }),
  },
  created() {
    this.getParameters();
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          clearInterval(this.timeoutDataTimer);

          this.data = data;
        })
        .catch((error) => {
          if (this.timeoutDataTimer == null) {
            this.timeoutDataTimer = setInterval(() => {
              this.getData();
            }, 3000);
          }

          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getParameters() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, null, "GET")
        .then((data) => {
          clearInterval(this.timeoutParametersTimer);

          this.parameters = data;

          let inputVoltageMax = [];
          let inputVoltageMin = [];
          let inputCurrentMax = [];
          let inputPowerMax = [];

          let outputVoltage = [];
          let outputCurrent = [];
          let outputPower = [];
          let outputFrequency = [];
          let outputPF = [];

          for (let i = 0; i < this.parameters.units.length; i++) {
            if (this.parameters.units[i].type.includes("EMPPT")) {
              for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                if (this.parameters.units[i].parameters[j].name == "InputVoltageRangeMin") {
                  inputVoltageMin.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "InputVoltageRangeMax") {
                  inputVoltageMax.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "InputCurrentMax") {
                  inputCurrentMax.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "InputPowerMax") {
                  inputPowerMax.push(this.parameters.units[i].parameters[j].value);
                }
              }
            } else if (this.parameters.units[i].type.includes("EINV")) {
              for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                if (this.parameters.units[i].parameters[j].name == "NominalVoltage") {
                  outputVoltage.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "NominalCurrent") {
                  outputCurrent.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "NominalPower") {
                  outputPower.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "NominalFrequency") {
                  outputFrequency.push(this.parameters.units[i].parameters[j].value);
                }
                if (this.parameters.units[i].parameters[j].name == "PowerFactor") {
                  outputPF.push(this.parameters.units[i].parameters[j].value);
                }
              }
            }
          }

          this.input = "DC, " + "1-4x, " + Math.min(...inputVoltageMin) + " - " + Math.max(...inputVoltageMax) + " V, " + Math.max(...inputCurrentMax) + " A, " + Math.max(...inputPowerMax) / 1000 + " kW";
          this.output = "AC, " + "1-3x, " + Math.max(...outputVoltage) + " V, " + Math.max(...outputFrequency) + " Hz, " + Math.max(...outputCurrent) + " A, " + Math.max(...outputPower) / 1000 + " kW, " + "cos \u03D5 = +-" + Math.min(...outputPF);
        })
        .catch((error) => {
          if (this.timeoutParametersTimer == null) {
            this.timeoutParametersTimer = setInterval(() => {
              this.getParameters();
            }, 3000);
          }

          this.parameters = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timeoutParametersTimer);
    clearInterval(this.timeoutDataTimer);
  },
};
</script>

<style scoped></style>
